import { IconTile } from "@design";
import { Palette } from "lucide-react";

// See AgentIcon: brand logos land with logo upload rendering; default tile for now.
export function BrandIcon() {
  return (
    <IconTile variant="neutral">
      <Palette size={16} aria-hidden />
    </IconTile>
  );
}
